/**
 * Error message to use
 */
type Msg = { [key in string]: string };
export const inputMessage: Msg = {
  required: 'Campo obligatorio',
  maxlength: 'No debe tener más de $COUNT caracteres.',
  minlength: 'Debe tener al menos $COUNT caracteres.',
};
